/* unplugin-vue-components disabled */import { render } from "./readBook.vue?vue&type=template&id=05b3545a&scoped=true&ts=true"
import script from "./readBook.vue?vue&type=script&lang=ts"
export * from "./readBook.vue?vue&type=script&lang=ts"

import "./readBook.vue?vue&type=style&index=0&id=05b3545a&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b3545a"]])

export default __exports__